import styled from 'styled-components';
import { Col, Collapse } from 'reactstrap';
import colors from '../../../../includes/colors';

export const Accordion = styled(Col)`
  border-top: 0.0625rem solid #aaa !important;
`;

export const AccordionList = styled.div`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const CollapseItem = styled(Collapse)`
  @media (min-width: 480px) {
    padding-left: 20px !important;
  }
  @media (min-width: 768px) {
    padding-left: 40px !important;
  }
`;

export const LinkTitle = styled.div`
  margin-left: 0;
  color: ${colors.blue} !important;
  font-size: 0.875rem;
  width: 100%;
  position: relative;
  list-style: none;
  display: block;
  width: 100%;
  cursor: pointer;
  padding-left: 1.25rem;
  &.active {
    .dds__icons {
      transform: rotate(90deg) !important;
    }
  }
  @media (min-width: 480px) {
    font-size: 1rem;
  }
  @media (min-width: 768px) {
    padding-left: 1.5rem;
    &:hover {
      text-decoration: underline;
      color: ${colors.darkBlue} !important;
    }
  }
`;

export const Icon = styled.div`
  display: block;
  position: absolute;
  font-weight: 900;
  font-size: inherit;
  left: 0px;
  transform: rotate(0deg);
  top: 50%;
  margin-top: -0.6rem;
  font-size: 1rem !important;
  transition: all 0.25s ease;
`;
